<template>
    <v-container fluid class="pt-0">
        <v-form ref="form" v-model="valid" lazy-validation id="form">
            <v-row>
                <v-col cols="12 text-left">
                    <p class="mb-0">* Campi obbligatori</p>
                </v-col>
                <v-col cols="12" sm="6" class="text-left">
                    <v-row>
                        <v-col cols="12" id="name">
                            <span class="pink title text-uppercase py-1 px-2">Tu sei</span>
                            <v-text-field v-model="name" :rules="rules.name" label="Nome*"
                                          color="AXABlue"
                                          v-scroll-to="'#name'"
                                          @click="checkPrivacy"
                                          required></v-text-field>
                        </v-col>
                        <v-col cols="12" id="date">
                            <v-text-field
                                    maxlength="10"
                                    @keyup="date=formatDate(date)"
                                    color="AXABlue"
                                    label="Data di nascita*"
                                    placeholder="GG/MM/AAAA"
                                    :rules="rules.date"
                                    v-model="date"
                                    type="tel"
                                    v-scroll-to="'#date'"
                                    @click="checkPrivacy"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="6" class="text-left">
                    <v-row>
                        <v-col cols="12" id="namePartner">
                            <span class="pink title text-uppercase py-1 px-2">{{ getInsTypeData.labelPartner }}</span>
                            <v-text-field v-model="namePartner" :rules="rules.name" label="Nome*"
                                          color="AXABlue"
                                          v-scroll-to="'#namePartner'"
                                          @click="checkPrivacy"
                                          required></v-text-field>
                        </v-col>
                        <v-col cols="12" id="datePartner">
                            <v-text-field
                                    maxlength="10"
                                    @keyup="datePartner=formatDate(datePartner)"
                                    color="AXABlue"
                                    label="Data di nascita*"
                                    placeholder="GG/MM/AAAA"
                                    :rules="rules.date"
                                    v-model="datePartner"
                                    type="tel"
                                    v-scroll-to="'#datePartner'"
                                    @click="checkPrivacy"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <!-- checkbox and privacy -->
            <v-row>
                <!-- checkbox -->
                <!--                <v-col cols="12" class="text-left py-0">
                                    <p class="radio-label mb-0 mr-4 d-inline-block">Acconsento al trattamento dei dati per finalità
                                        commerciali</p>
                                    <v-radio-group v-model="commerciali" required row class="justify-center d-inline-block mt-0 pt-0">
                                        <v-radio color="AXABlue" label="Si" value="radio-1"></v-radio>
                                        <v-radio color="AXABlue" label="No" value="radio-2"></v-radio>
                                    </v-radio-group>
                                </v-col>-->
            </v-row>
        </v-form>
        <!-- privacy -->
        <v-dialog v-model="privacyDialog" scrollable persistent max-width="960" class="dialog">
            <v-card tile class="py-5">
                <v-card-title class="px-3 dialog__card__title py-3">
                    <v-row>
                        <v-col cols="12" class="text-center py-0 py-md-3">
                            <h2 class="mb-3 mb-md-6 display-2 mt-3">Informativa privacy</h2>
                            <h3>Informativa privacy</h3>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="px-3 dialog__card__text px-8 py-0">
                    <v-row>
                        <v-col cols="12" class="text-md-left text_container">
                            La informiamo che i suoi dati personali sono trattati da <strong>AXA MPS Assicurazioni Vita S.p.A</strong>., titolare del trattamento, per gestire la sua richiesta ed i servizi assicurativi connessi. I dati raccolti potranno, inoltre, essere trattati per attività statistiche interne connesse alla fornitura del servizio erogato (finalità assicurativa).<br/>
                            <br/>
                            Inoltre, i dati identificativi e di contatto sono trattati dalla <strong>Banca Monte dei Paschi di Siena S.p.A</strong>., titolare autonomo del trattamento e intermediario assicurativo, per verificare la sua qualità di cliente della banca stessa.<br/>
                            <br/>
                            Per esercitare i Suoi diritti (accedere ai suoi dati personali, farli aggiornare, integrare, rettificare o cancellare, di chiederne la limitazione e di opporsi al loro trattamento, richiedere la portabilità dei dati, revocare i consensi espressi e, per il processo di decisione automatizzata, ottenere l'intervento umano da parte del titolare del trattamento, esprimere la propria opinione e contestare la decisione, ottenere informazioni sui trasferimenti verso paesi che non fanno parte dell'Unione Europea e, con riferimento ad AXA MPS, informazioni sul legittimo interesse) può scrivere a:<br/>
                            <br/>
                            - <strong>AXA MPS Assicurazioni Vita S.p.A.</strong> – c.a. Data Protection Officer – Via Aldo Fabrizi, 9 - 00128 Roma (RM) - e-mail: <a href="mailto:privacy@axa.it">privacy@axa.it</a>.<br/>
                            - <strong>Banca Monte dei Paschi di Siena S.p.A.</strong> - Staff DPO e Advisory Privacy, Via A. Moro n. 11/13 - 53100 Siena (fax + 39 0577 296520; e-mail: <a href="mailto:privacy@mps.it">privacy@mps.it</a>).<br/>
                            <br/>
                            Per maggiori informazioni, può leggere l'<a href="/docs/mps/privacy_2026.pdf" target="_blank" class="privacy__link">informativa estesa</a>.<br/>
                            <br/>
                            Inoltre, Lei potrà proporre reclamo all'Autorità di controllo in materia di protezione dei dati personali, in Italia il Garante per la protezione dei dati personali: Piazza Venezia n. 11 - 00187 Roma (+39) 06.696771; <a href="mailto:protocollo@pec.gpdp.it">protocollo@pec.gpdp.it</a><br/>
                            <br/>
                            <span class="red--text">Attenzione: il servizio è disponibile solo per i maggiorenni</span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-title class="mt-5 v-card__footer py-0">
                    <v-col cols="12" class="text-center">
                        <div class="dialog__card__text text_container">
                            Per visualizzare l'informativa completa, <a href="/docs/mps/privacy_2026.pdf" target="_blank" class="privacy__link">Clicca qui</a>
                        </div>
                    </v-col>
                    <v-col cols="12" class="text-center pb-0">
                        <v-btn x-large tile elevation="0" @click="privacyDialog = false, privacy=true"
                               class="pinkDark white--text">
                            HO CAPITO
                        </v-btn>
                    </v-col>
                </v-card-title>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import * as moment from 'moment';

    export default {
        name: "Form",
        components: {},
        data: vm => ({
            valid: false,
            privacy: false,
            privacyDialog: false,
            name: '',
            date: '',
            rules: {
                date: [
                    val => moment(val, "DD/MM/YYYY") >= moment().subtract(60, 'years') && moment(val, "DD/MM/YYYY") <= moment().subtract(18, 'years') || `L'età deve essere compresa tra 18 e 60 anni`,
                    val => /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/i.test(val) || 'La data deve avere formato gg/mm/aaaa',
                ],
                name: [val => (val || '').length > 0 || 'Campo obbligatorio'],
            },
            namePartner: '',
            datePartner: '',
            //commerciali: '',
            cont: 1,
            formId: 'personForm',
            idSession: sessionStorage.getItem('sessionId'),
        }),
        computed: {
            ...mapGetters({
                'getInsuredData': 'params/getInsuredData',
                'getInsTypeData' : 'params/getInsTypeData'
            }),
        },
        mounted() {
            this.actionInsTypeData();
            //console.log(this.getInsuredData);
            if (this.getInsuredData.name) {
                this.name = this.getInsuredData.name;
                this.date = this.getInsuredData.date;
                this.namePartner = this.getInsuredData.namePartner;
                this.datePartner = this.getInsuredData.datePartner;
                //this.commerciali = this.getInsuredData.commerciali;
            }
        },
        methods: {
            ...mapActions({
                'actionIsFormValidate': 'stickyBar/actionIsFormValidate',
                'actionIsDisable': 'stickyBar/actionIsDisable',
                'actionInsTypeData': 'params/actionInsTypeData',
                'actionInsuredData': 'params/actionInsuredData'
            }),
            checkPrivacy($event) {
                if (!this.privacy) {
                    if ($event && $event.target) {
                        $event.target.blur();
                    }
                    if (this.$refs.form) {
                        this.$refs.form.resetValidation();
                    }
                    this.privacyDialog = true;
                }
            },
            formatDate: function (value) {
                value = value.replace(/\D/g, "")
                    .split(/(..)/)
                    .filter(s => s.length > 0)
                    .reduce((t, v, i, a) => t + v + (i > 1 || i == a.length - 1 ? '' : '/'), '');
                return value;
            }
        },
        updated() {
            let data = {};
            data.name = this.name;
            data.date = this.date;
            data.namePartner = this.namePartner;
            data.datePartner = this.datePartner;
            //data.commerciali = this.commerciali;

            this.actionInsuredData(data);
            if (this.name != '' && this.date != '' && this.namePartner != '' && this.datePartner != '' && this.valid) {
                this.actionIsDisable(false);
                this.actionIsFormValidate(true);
            } else {
                this.actionIsDisable(true);
                this.actionIsFormValidate(false);
            }
        },
    };
</script>
